
  
    <div class="ng-Header">
      <i nz-icon nzType="form" nzTheme="outline"></i> Update Contact Information
    </div>
    <div class="">
      <form nz-form [formGroup]="basicProfileForm">
        <div class="form-row ml-15">
          <b style="margin-left: 15px">Address of the Organization</b>
          <hr />
        </div>
          <div class="form-row" style="margin-left: 12px">
            <div class=" col-md-4">
              <nz-form-label nzRequired>Contact Number</nz-form-label>
              <div class=" col-md-12">
                <nz-form-item>
                  <nz-form-control [nzSpan]="20" nzHasFeedback [nzErrorTip]="contactNumberErrorTpl">
                    <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                      <ng-template #addOnBeforeTemplate>
                        <nz-select formControlName="contactNumberPrefixForContactNo" class="phone-select">
                          <nz-option nzLabel="+880" nzValue="+880"></nz-option>
                        </nz-select>
                      </ng-template>
                      <input formControlName="organizationContactNo" id="organizationContactNo" placeholder="Contact Number" nz-input />
                    </nz-input-group>
                    <ng-template #contactNumberErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        Please input your contact number!
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        Max Length Reached
                      </ng-container>
                      <ng-container *ngIf="control.hasError('minlength')">
                        Contact Number Must be 10 digit
                      </ng-container>
                      <ng-container *ngIf="control.hasError('pattern')">
                        <div>Only Digits are allowed</div>
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
    
            <div class=" col-md-4">
              <nz-form-label nzRequired>Email Address</nz-form-label>
              <div class=" col-md-12">
                <nz-form-item>
                  <nz-form-control [nzSpan]="20" nzHasFeedback [nzErrorTip]="emailErrorTpl">
                    <input nz-input formControlName="organizationEmail" placeholder="E-mail" />
                    <ng-template #emailErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('email')">
                        The input is not valid E-mail!
                      </ng-container>
                      <ng-container *ngIf="control.hasError('required')">
                        Please input your E-mail!
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>

          <div class="form-row ml-15">
            <b style="margin-left: 15px">Owner/Principal/Head of the STP</b>
            <hr />
          </div>
          <div class="form-row" style="margin-left: 12px">

            <div class=" col-md-4">
              <nz-form-label nzRequired>Name</nz-form-label>
              <div class=" col-md-12">
                <nz-form-item>
                  <nz-form-control [nzSpan]="20" nzHasFeedback nzValidatingTip="Validating..."
                    [nzErrorTip]="basicProfileErrorTpl">
                    <input nz-input formControlName="representativeName" placeholder="Representative Name" />
                    <ng-template #basicProfileErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        Please input name!
                      </ng-container>
                      <ng-container *ngIf="control.hasError('duplicated')">
                        This data is redundant!
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
    
            <div class=" col-md-4">
              <nz-form-label nzRequired>Designation</nz-form-label>
              <div class=" col-md-12">
                <nz-form-item>
                  <nz-form-control [nzSpan]="20" nzHasFeedback nzValidatingTip="Validating..."
                    [nzErrorTip]="basicProfileErrorTpl">
                    <input nz-input formControlName="representativeDesignation" placeholder="Designation" />
                    <ng-template #basicProfileErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        Please input name!
                      </ng-container>
                      <ng-container *ngIf="control.hasError('duplicated')">
                        This data is redundant!
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div class=" col-md-4">
              <nz-form-label nzRequired>Contact Number</nz-form-label>
              <div class=" col-md-12">
                <nz-form-item>
                  <nz-form-control [nzSpan]="20" nzHasFeedback [nzErrorTip]="contactNumberErrorTpl">
                    <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                      <ng-template #addOnBeforeTemplate>
                        <nz-select formControlName="representativeContactNo" class="phone-select">
                          <nz-option nzLabel="+880" nzValue="+880"></nz-option>
                        </nz-select>
                      </ng-template>
                      <input formControlName="representativeContactNo" id="representativeContactNo" placeholder="Contact Number" nz-input />
                    </nz-input-group>
                    <ng-template #contactNumberErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        Please input your contact number!
                      </ng-container>
                      <ng-container *ngIf="control.hasError('maxlength')">
                        Max Length Reached
                      </ng-container>
                      <ng-container *ngIf="control.hasError('minlength')">
                        Contact Number Must be 10 digit
                      </ng-container>
                      <ng-container *ngIf="control.hasError('pattern')">
                        <div>Only Digits are allowed</div>
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

          </div>

          <div class="form-row" style="margin-left: 12px">
            <div class=" col-md-4">
              <nz-form-label nzRequired>Email</nz-form-label>
              <div class=" col-md-12">
                <nz-form-item>
                  <nz-form-control [nzSpan]="20" nzHasFeedback [nzErrorTip]="emailErrorTpl">
                    <input nz-input formControlName="representativeEmail" placeholder="E-mail" />
                    <ng-template #emailErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('email')">
                        The input is not valid E-mail!
                      </ng-container>
                      <ng-container *ngIf="control.hasError('required')">
                        Please input your E-mail!
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>


        <div class="row justify-content-center media-button">

          <div class="col-xs-6 col-sm-2">
            <button type="button" class="btn btn-success active btn-lg btn-block cari border-redius"
              [disabled]="!basicProfileForm.valid" (click)="update()"><i nz-icon nzType="save" nzTheme="fill"></i>
              Update</button>


          </div>
        </div>
      </form>
    </div>
  

